// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import MenuList from './MenuList';
import MobileMenu from './MobileMenu';
import MiniNav from './MiniNav';
import { formatPhone } from '../../_common/api/utility';
import { Link } from 'react-router-dom';
import HamLink from '../../_common/form/HamLink';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const MiniWrapper = styled.div`
    position: sticky;
    z-index: 100;
    transition: all 0.5s;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.secondary};
    width: 100%;
    
`;
export const MiniBar = styled.div`
    width: 100vw;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
    background: ${({ theme }) => theme.tertiary};
    min-height: 0.2rem;
    z-index: 100;

    font-size: 0.5em;
`
const Highlight = styled(HamLink)`
    text-decoration: none;
    font-weight: bold;
`
const Img = styled(Link)`
    width: 12%;
    margin: 0 2em;
    display: flex;
    align-items: center;
    justify-content: center;
`
const TopNav = ({ showMini, children, ...props }) => {
    const {
        state: {
            site_config
        },
    } = useGlobalState();

    return (
        <>
            <MiniNav showMini={showMini} />
            <Wrapper>
                <MiniBar>
                    {site_config.contact.phone ? <div><Highlight href={`tel:${site_config.contact.phone}`}> {formatPhone(site_config.contact.phone)}</Highlight></div> : null}
                    <Highlight to={site_config.menuItems.find(e => e.tag === '_LOCATIONS').href}>Find Us!</Highlight>
                </MiniBar>
                <MiniWrapper>
                    <Img to={site_config.menuItems.find(e => e.tag === '_HOME')?.href}>
                        <img
                            style={{
                                height: '4em',
                                margin: '0.2em 2em',
                                maxHeight: '4em',
                            }}
                            src={site_config.logo}
                            alt='logo'
                        />
                    </Img>
                    <MenuList />
                </MiniWrapper>
                <MiniBar />
            </Wrapper>
        </>
    );
}

export default TopNav;